import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import {
  FetchLogisticsDailySummaries,
  ILogisticsDailySummaryApiResponse,
  logisticsActionCreators,
  LogisticsActionKeys
} from '..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* fetchLogisticsDailySummariesSaga(action: FetchLogisticsDailySummaries) {
  yield put(uiActionCreators.toggleLoading('logisticsDailySummaries'));
  const response = yield* call(fetchDailySummaries, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setDailySummaries(response.value));
  }

  yield put(uiActionCreators.toggleLoading('logisticsDailySummaries'));
}

export function* watchFetchLogisticsDailySummaries() {
  yield takeEvery(LogisticsActionKeys.FETCH_LOGISTICS_DAILY_SUMMARIES, fetchLogisticsDailySummariesSaga);
}

export async function fetchDailySummaries(values: {
  startDate: Date;
  endDate: Date;
}): Promise<IApiExecuteRespone<ILogisticsDailySummaryApiResponse[]>> {
  return executeApiRequest(() =>
    httpService.get(
      `/Logistics/DailySummaries?startDate=${values.startDate.toISOString()}&endDate=${values.endDate.toISOString()}`
    )
  );
}
